import { AFFILIATE_REQUEST_STATUSES, EARNING_STATUSES, INVOICE_STATUSES } from './data-service.interface';

export const COUNTRIES_TRANSLATIONS = {
  AF: $localize`:@@countries.afghanistan:Afghanistan`,
  AX: $localize`:@@countries.aland_islands:Aland Islands`,
  AL: $localize`:@@countries.albania:Albania`,
  DZ: $localize`:@@countries.algeria:Algeria`,
  AS: $localize`:@@countries.american_samoa:American Samoa`,
  AD: $localize`:@@countries.andorra:Andorra`,
  AO: $localize`:@@countries.angola:Angola`,
  AI: $localize`:@@countries.anguilla:Anguilla`,
  AQ: $localize`:@@countries.antarctica:Antarctica`,
  AG: $localize`:@@countries.antigua_and_barbuda:Antigua and Barbuda`,
  AR: $localize`:@@countries.argentina:Argentina`,
  AM: $localize`:@@countries.armenia:Armenia`,
  AW: $localize`:@@countries.aruba:Aruba`,
  AU: $localize`:@@countries.australia:Australia`,
  AT: $localize`:@@countries.austria:Austria`,
  AZ: $localize`:@@countries.azerbaijan:Azerbaijan`,
  BS: $localize`:@@countries.bahamas:Bahamas`,
  BH: $localize`:@@countries.bahrain:Bahrain`,
  BD: $localize`:@@countries.bangladesh:Bangladesh`,
  BB: $localize`:@@countries.barbados:Barbados`,
  BY: $localize`:@@countries.belarus:Belarus`,
  BE: $localize`:@@countries.belgium:Belgium`,
  BZ: $localize`:@@countries.belize:Belize`,
  BJ: $localize`:@@countries.benin:Benin`,
  BM: $localize`:@@countries.bermuda:Bermuda`,
  BT: $localize`:@@countries.bhutan:Bhutan`,
  BO: $localize`:@@countries.bolivia:Bolivia`,
  BA: $localize`:@@countries.bosnia_and_herzegovina:Bosnia and Herzegovina`,
  BW: $localize`:@@countries.botswana:Botswana`,
  BV: $localize`:@@countries.bouvet_island:Bouvet Island`,
  BR: $localize`:@@countries.brazil:Brazil`,
  IO: $localize`:@@countries.british_indian_ocean_territory:British Indian Ocean Territory`,
  BN: $localize`:@@countries.brunei_darussalam:Brunei Darussalam`,
  BG: $localize`:@@countries.bulgaria:Bulgaria`,
  BF: $localize`:@@countries.burkina_faso:Burkina Faso`,
  BI: $localize`:@@countries.burundi:Burundi`,
  KH: $localize`:@@countries.cambodia:Cambodia`,
  CM: $localize`:@@countries.cameroon:Cameroon`,
  CA: $localize`:@@countries.canada:Canada`,
  CV: $localize`:@@countries.cape_verde:Cape Verde`,
  KY: $localize`:@@countries.cayman_islands:Cayman Islands`,
  CF: $localize`:@@countries.central_african_republic:Central African Republic`,
  TD: $localize`:@@countries.chad:Chad`,
  CL: $localize`:@@countries.chile:Chile`,
  CN: $localize`:@@countries.china:China`,
  CX: $localize`:@@countries.christmas_island:Christmas Island`,
  CC: $localize`:@@countries.cocos_islands:Cocos (Keeling) Islands`,
  CO: $localize`:@@countries.colombia:Colombia`,
  KM: $localize`:@@countries.comoros:Comoros`,
  CG: $localize`:@@countries.congo:Congo`,
  CD: $localize`:@@countries.democratic_republic_of_the_congo:Democratic Republic of the Congo`,
  CK: $localize`:@@countries.cook_islands:Cook Islands`,
  CR: $localize`:@@countries.costa_rica:Costa Rica`,
  CI: $localize`:@@countries.cote_d_ivoire:Cote dIvoire`,
  HR: $localize`:@@countries.croatia:Croatia`,
  CU: $localize`:@@countries.cuba:Cuba`,
  CW: $localize`:@@countries.curacao:Curacao`,
  CY: $localize`:@@countries.cyprus:Cyprus`,
  CZ: $localize`:@@countries.czech_republic:Czech Republic`,
  DK: $localize`:@@countries.denmark:Denmark`,
  DJ: $localize`:@@countries.djibouti:Djibouti`,
  DM: $localize`:@@countries.dominica:Dominica`,
  DO: $localize`:@@countries.dominican_republic:Dominican Republic`,
  EC: $localize`:@@countries.ecuador:Ecuador`,
  EG: $localize`:@@countries.egypt:Egypt`,
  SV: $localize`:@@countries.el_salvador:El Salvador`,
  GQ: $localize`:@@countries.equatorial_guinea:Equatorial Guinea`,
  ER: $localize`:@@countries.eritrea:Eritrea`,
  EE: $localize`:@@countries.estonia:Estonia`,
  ET: $localize`:@@countries.ethiopia:Ethiopia`,
  FK: $localize`:@@countries.falkland_islands:Falkland Islands (Malvinas)`,
  FO: $localize`:@@countries.faroe_islands:Faroe Islands`,
  FJ: $localize`:@@countries.fiji:Fiji`,
  FI: $localize`:@@countries.finland:Finland`,
  FR: $localize`:@@countries.france:France`,
  GF: $localize`:@@countries.french_guiana:French Guiana`,
  PF: $localize`:@@countries.french_polynesia:French Polynesia`,
  TF: $localize`:@@countries.french_southern_territories:French Southern Territories`,
  GA: $localize`:@@countries.gabon:Gabon`,
  GM: $localize`:@@countries.gambia:Gambia`,
  GE: $localize`:@@countries.georgia:Georgia`,
  DE: $localize`:@@countries.germany:Germany`,
  GH: $localize`:@@countries.ghana:Ghana`,
  GI: $localize`:@@countries.gibraltar:Gibraltar`,
  GR: $localize`:@@countries.greece:Greece`,
  GL: $localize`:@@countries.greenland:Greenland`,
  GD: $localize`:@@countries.grenada:Grenada`,
  GP: $localize`:@@countries.guadeloupe:Guadeloupe`,
  GU: $localize`:@@countries.guam:Guam`,
  GT: $localize`:@@countries.guatemala:Guatemala`,
  GG: $localize`:@@countries.guernsey:Guernsey`,
  GN: $localize`:@@countries.guinea:Guinea`,
  GW: $localize`:@@countries.guinea_bissau:Guinea-Bissau`,
  GY: $localize`:@@countries.guyana:Guyana`,
  HT: $localize`:@@countries.haiti:Haiti`,
  HM: $localize`:@@countries.heard_island_and_mcdonald_islands:Heard Island and McDonald Islands`,
  VA: $localize`:@@countries.holy_see:Holy See (Vatican City State)`,
  HN: $localize`:@@countries.honduras:Honduras`,
  HK: $localize`:@@countries.hong_kong:Hong Kong`,
  HU: $localize`:@@countries.hungary:Hungary`,
  IS: $localize`:@@countries.iceland:Iceland`,
  IN: $localize`:@@countries.india:India`,
  ID: $localize`:@@countries.indonesia:Indonesia`,
  IR: $localize`:@@countries.islamic_republic_of_iran:Islamic Republic of Iran`,
  IQ: $localize`:@@countries.iraq:Iraq`,
  IE: $localize`:@@countries.ireland:Ireland`,
  IM: $localize`:@@countries.isle_of_man:Isle of Man`,
  IL: $localize`:@@countries.israel:Israel`,
  IT: $localize`:@@countries.italy:Italy`,
  JM: $localize`:@@countries.jamaica:Jamaica`,
  JP: $localize`:@@countries.japan:Japan`,
  JE: $localize`:@@countries.jersey:Jersey`,
  JO: $localize`:@@countries.jordan:Jordan`,
  KZ: $localize`:@@countries.kazakhstan:Kazakhstan`,
  KE: $localize`:@@countries.kenya:Kenya`,
  KI: $localize`:@@countries.kiribati:Kiribati`,
  KR: $localize`:@@countries.republic_of_korea:Republic of Korea`,
  XK: $localize`:@@countries.kosovo:Kosovo`,
  KW: $localize`:@@countries.kuwait:Kuwait`,
  KG: $localize`:@@countries.kyrgyzstan:Kyrgyzstan`,
  LA: $localize`:@@countries.lao_peoples_democratic_republic:Lao Peoples Democratic Republic`,
  LV: $localize`:@@countries.latvia:Latvia`,
  LB: $localize`:@@countries.lebanon:Lebanon`,
  LS: $localize`:@@countries.lesotho:Lesotho`,
  LR: $localize`:@@countries.liberia:Liberia`,
  LY: $localize`:@@countries.libyan_arab_jamahiriya:Libyan Arab Jamahiriya`,
  LI: $localize`:@@countries.liechtenstein:Liechtenstein`,
  LT: $localize`:@@countries.lithuania:Lithuania`,
  LU: $localize`:@@countries.luxembourg:Luxembourg`,
  MO: $localize`:@@countries.macao:Macao`,
  MK: $localize`:@@countries.macedonia_the_former_republic_of:Macedonia, the Former Republic of`,
  MG: $localize`:@@countries.madagascar:Madagascar`,
  MW: $localize`:@@countries.malawi:Malawi`,
  MY: $localize`:@@countries.malaysia:Malaysia`,
  MV: $localize`:@@countries.maldives:Maldives`,
  ML: $localize`:@@countries.mali:Mali`,
  MT: $localize`:@@countries.malta:Malta`,
  MH: $localize`:@@countries.marshall_islands:Marshall Islands`,
  MQ: $localize`:@@countries.martinique:Martinique`,
  MR: $localize`:@@countries.mauritania:Mauritania`,
  MU: $localize`:@@countries.mauritius:Mauritius`,
  YT: $localize`:@@countries.mayotte:Mayotte`,
  MX: $localize`:@@countries.mexico:Mexico`,
  FM: $localize`:@@countries.micronesia_federated_states_of:Micronesia, Federated States of`,
  MD: $localize`:@@countries.moldova_republic_of:Moldova, Republic of`,
  MC: $localize`:@@countries.monaco:Monaco`,
  MN: $localize`:@@countries.mongolia:Mongolia`,
  ME: $localize`:@@countries.montenegro:Montenegro`,
  MS: $localize`:@@countries.montserrat:Montserrat`,
  MA: $localize`:@@countries.morocco:Morocco`,
  MZ: $localize`:@@countries.mozambique:Mozambique`,
  MM: $localize`:@@countries.myanmar:Myanmar`,
  NA: $localize`:@@countries.namibia:Namibia`,
  NR: $localize`:@@countries.nauru:Nauru`,
  NP: $localize`:@@countries.nepal:Nepal`,
  NL: $localize`:@@countries.netherlands:Netherlands`,
  AN: $localize`:@@countries.netherlands_antilles:Netherlands Antilles`,
  NC: $localize`:@@countries.new_caledonia:New Caledonia`,
  NZ: $localize`:@@countries.new_zealand:New Zealand`,
  NI: $localize`:@@countries.nicaragua:Nicaragua`,
  NE: $localize`:@@countries.niger:Niger`,
  NG: $localize`:@@countries.nigeria:Nigeria`,
  NU: $localize`:@@countries.niue:Niue`,
  NF: $localize`:@@countries.norfolk_island:Norfolk Island`,
  MP: $localize`:@@countries.northern_mariana_islands:Northern Mariana Islands`,
  NO: $localize`:@@countries.norway:Norway`,
  OM: $localize`:@@countries.oman:Oman`,
  PK: $localize`:@@countries.pakistan:Pakistan`,
  PW: $localize`:@@countries.palau:Palau`,
  PS: $localize`:@@countries.palestinian_territory:Palestinian Territory`,
  PA: $localize`:@@countries.panama:Panama`,
  PG: $localize`:@@countries.papua_new_guinea:Papua New Guinea`,
  PY: $localize`:@@countries.paraguay:Paraguay`,
  PE: $localize`:@@countries.peru:Peru`,
  PH: $localize`:@@countries.philippines:Philippines`,
  PN: $localize`:@@countries.pitcairn:Pitcairn`,
  PL: $localize`:@@countries.poland:Poland`,
  PT: $localize`:@@countries.portugal:Portugal`,
  PR: $localize`:@@countries.puerto_rico:Puerto Rico`,
  QA: $localize`:@@countries.qatar:Qatar`,
  RE: $localize`:@@countries.reunion:Reunion`,
  RO: $localize`:@@countries.romania:Romania`,
  RU: $localize`:@@countries.russia:Russia`,
  RW: $localize`:@@countries.rwanda:Rwanda`,
  BL: $localize`:@@countries.saint_barthelemy:Saint Barthelemy`,
  SH: $localize`:@@countries.saint_helena:Saint Helena`,
  KN: $localize`:@@countries.saint_kitts_and_nevis:Saint Kitts and Nevis`,
  LC: $localize`:@@countries.saint_lucia:Saint Lucia`,
  MF: $localize`:@@countries.saint_martin:Saint Martin`,
  SX: $localize`:@@countries.sint_maarten:Sint Marteen`,
  PM: $localize`:@@countries.saint_pierre_and_miquelon:Saint Pierre and Miquelon`,
  VC: $localize`:@@countries.saint_vincent_and_the_grenadines:Saint Vincent and the Grenadines`,
  WS: $localize`:@@countries.samoa:Samoa`,
  SM: $localize`:@@countries.san_marino:San Marino`,
  ST: $localize`:@@countries.sao_tome_and_principe:Sao Tome and Principe`,
  SA: $localize`:@@countries.saudi_arabia:Saudi Arabia`,
  SN: $localize`:@@countries.senegal:Senegal`,
  RS: $localize`:@@countries.serbia:Serbia`,
  SC: $localize`:@@countries.seychelles:Seychelles`,
  SL: $localize`:@@countries.sierra_leone:Sierra Leone`,
  SG: $localize`:@@countries.singapore:Singapore`,
  SK: $localize`:@@countries.slovakia:Slovakia`,
  SI: $localize`:@@countries.slovenia:Slovenia`,
  SB: $localize`:@@countries.solomon_islands:Solomon Islands`,
  SO: $localize`:@@countries.somalia:Somalia`,
  ZA: $localize`:@@countries.south_africa:South Africa`,
  GS: $localize`:@@countries.south_georgia_and_the_south_sandwich_islands:South Georgia and the South Sandwich Islands`,
  ES: $localize`:@@countries.spain:Spain`,
  LK: $localize`:@@countries.sri_lanka:Sri Lanka`,
  SD: $localize`:@@countries.sudan:Sudan`,
  SR: $localize`:@@countries.suriname:Suriname`,
  SJ: $localize`:@@countries.svalbard_and_jan_mayen:Svalbard and Jan Mayen`,
  SZ: $localize`:@@countries.swaziland:Swaziland`,
  SE: $localize`:@@countries.sweden:Sweden`,
  CH: $localize`:@@countries.switzerland:Switzerland`,
  SY: $localize`:@@countries.syrian_arab_republic:Syrian Arab Republic`,
  TW: $localize`:@@countries.taiwan_province_of_china:Taiwan, province of China`,
  TJ: $localize`:@@countries.tajikistan:Tajikistan`,
  TZ: $localize`:@@countries.tanzania_united_republic_of:Tanzania, United Republic of`,
  TH: $localize`:@@countries.thailand:Thailand`,
  TL: $localize`:@@countries.timor_leste:Timor-Leste`,
  TG: $localize`:@@countries.togo:Togo`,
  TK: $localize`:@@countries.tokelau:Tokelau`,
  TO: $localize`:@@countries.tonga:Tonga`,
  TT: $localize`:@@countries.trinidad_and_tobago:Trinidad and Tobago`,
  TN: $localize`:@@countries.tunisia:Tunisia`,
  TR: $localize`:@@countries.turkey:Turkey`,
  TM: $localize`:@@countries.turkmenistan:Turkmenistan`,
  TC: $localize`:@@countries.turks_and_caicos_islands:Turks and Caicos Islands`,
  TV: $localize`:@@countries.tuvalu:Tuvalu`,
  UG: $localize`:@@countries.uganda:Uganda`,
  UA: $localize`:@@countries.ukraine:Ukraine`,
  AE: $localize`:@@countries.united_arab_emirates:United Arab Emirates`,
  GB: $localize`:@@countries.united_kingdom:United Kingdom`,
  US: $localize`:@@countries.united_states:United States`,
  UM: $localize`:@@countries.united_states_minor_outlying_islands:United States Minor Outlying Islands`,
  UY: $localize`:@@countries.uruguay:Uruguay`,
  UZ: $localize`:@@countries.uzbekistan:Uzbekistan`,
  VU: $localize`:@@countries.vanuatu:Vanuatu`,
  VE: $localize`:@@countries.venezuela:Venezuela`,
  VN: $localize`:@@countries.viet_nam:Viet Nam`,
  VG: $localize`:@@countries.virgin_islands_british:Virgin Islands, British`,
  VI: $localize`:@@countries.virgin_islands_us:Virgin Islands, U.S.`,
  WF: $localize`:@@countries.wallis_and_futuna:Wallis and Futuna`,
  EH: $localize`:@@countries.western_sahara:Western Sahara`,
  YE: $localize`:@@countries.yemen:Yemen`,
  ZM: $localize`:@@countries.zambia:Zambia`,
  ZW: $localize`:@@countries.zimbabwe:Zimbabwe`,
};

export const LANGUAGES_TRANSLATIONS = {
  aa: $localize`:@@languages.afar:Afar`,
  ab: $localize`:@@languages.abkhaz:Abkhaz`,
  ae: $localize`:@@languages.avestan:Avestan`,
  af: $localize`:@@languages.afrikaans:Afrikaans`,
  ak: $localize`:@@languages.akan:Akan`,
  am: $localize`:@@languages.amharic:Amharic`,
  an: $localize`:@@languages.aragonese:Aragonese`,
  ar: $localize`:@@languages.arabic:Arabic`,
  as: $localize`:@@languages.assamese:Assamese`,
  av: $localize`:@@languages.avaric:Avaric`,
  ay: $localize`:@@languages.aymara:Aymara`,
  az: $localize`:@@languages.south azerbaijani:South Azerbaijani`,
  ba: $localize`:@@languages.bashkir:Bashkir`,
  be: $localize`:@@languages.belarusian:Belarusian`,
  bg: $localize`:@@languages.bulgarian:Bulgarian`,
  bh: $localize`:@@languages.bihari:Bihari`,
  bi: $localize`:@@languages.bislama:Bislama`,
  bm: $localize`:@@languages.bambara:Bambara`,
  bn: $localize`:@@languages.bengali:Bengali`,
  bo: $localize`:@@languages.tibetan:Tibetan`,
  br: $localize`:@@languages.breton:Breton`,
  bs: $localize`:@@languages.bosnian:Bosnian`,
  ca: $localize`:@@languages.catalan:Catalan`,
  ce: $localize`:@@languages.chechen:Chechen`,
  ch: $localize`:@@languages.chamorro:Chamorro`,
  co: $localize`:@@languages.corsican:Corsican`,
  cr: $localize`:@@languages.cree:Cree`,
  cs: $localize`:@@languages.czech:Czech`,
  cu: $localize`:@@languages.church slavonic:Church Slavonic`,
  cv: $localize`:@@languages.chuvash:Chuvash`,
  cy: $localize`:@@languages.welsh:Welsh`,
  da: $localize`:@@languages.danish:Danish`,
  de: $localize`:@@languages.german:German`,
  dv: $localize`:@@languages.maldivian:Maldivian`,
  dz: $localize`:@@languages.dzongkha:Dzongkha`,
  ee: $localize`:@@languages.ewe:Ewe`,
  el: $localize`:@@languages.greek:Greek`,
  en: $localize`:@@languages.english:English`,
  eo: $localize`:@@languages.esperanto:Esperanto`,
  es: $localize`:@@languages.spanish:Spanish`,
  et: $localize`:@@languages.estonian:Estonian`,
  eu: $localize`:@@languages.basque:Basque`,
  fa: $localize`:@@languages.persian:Persian`,
  ff: $localize`:@@languages.fula:Fula`,
  fi: $localize`:@@languages.finnish:Finnish`,
  fj: $localize`:@@languages.fijian:Fijian`,
  fo: $localize`:@@languages.faroese:Faroese`,
  fr: $localize`:@@languages.french:French`,
  fy: $localize`:@@languages.western frisian:Western Frisian`,
  ga: $localize`:@@languages.irish:Irish`,
  gd: $localize`:@@languages.gaelic:Gaelic`,
  gl: $localize`:@@languages.galician:Galician`,
  gn: $localize`:@@languages.guarana:Guarana`,
  gu: $localize`:@@languages.gujarati:Gujarati`,
  gv: $localize`:@@languages.manx:Manx`,
  ha: $localize`:@@languages.hausa:Hausa`,
  he: $localize`:@@languages.hebrew:Hebrew`,
  hi: $localize`:@@languages.hindi:Hindi`,
  ho: $localize`:@@languages.hiri motu:Hiri Motu`,
  hr: $localize`:@@languages.croatian:Croatian`,
  ht: $localize`:@@languages.haitian:Haitian`,
  hu: $localize`:@@languages.hungarian:Hungarian`,
  hy: $localize`:@@languages.armenian:Armenian`,
  hz: $localize`:@@languages.herero:Herero`,
  ia: $localize`:@@languages.interlingua:Interlingua`,
  id: $localize`:@@languages.indonesian:Indonesian`,
  ie: $localize`:@@languages.interlingue:Interlingue`,
  ig: $localize`:@@languages.igbo:Igbo`,
  ii: $localize`:@@languages.nuosu:Nuosu`,
  ik: $localize`:@@languages.inupiaq:Inupiaq`,
  io: $localize`:@@languages.ido:Ido`,
  is: $localize`:@@languages.icelandic:Icelandic`,
  it: $localize`:@@languages.italian:Italian`,
  iu: $localize`:@@languages.inuktitut:Inuktitut`,
  ja: $localize`:@@languages.japanese:Japanese`,
  jv: $localize`:@@languages.javanese:Javanese`,
  ka: $localize`:@@languages.georgian:Georgian`,
  kg: $localize`:@@languages.kongo:Kongo`,
  ki: $localize`:@@languages.kikuyu:Kikuyu`,
  kj: $localize`:@@languages.kwanyama:Kwanyama`,
  kk: $localize`:@@languages.kazakh:Kazakh`,
  kl: $localize`:@@languages.greenlandic:Greenlandic`,
  km: $localize`:@@languages.khmer:Khmer`,
  kn: $localize`:@@languages.kannada:Kannada`,
  ko: $localize`:@@languages.korean:Korean`,
  kr: $localize`:@@languages.kanuri:Kanuri`,
  ks: $localize`:@@languages.kashmiri:Kashmiri`,
  ku: $localize`:@@languages.kurdish:Kurdish`,
  kv: $localize`:@@languages.komi:Komi`,
  kw: $localize`:@@languages.cornish:Cornish`,
  ky: $localize`:@@languages.kyrgyz:Kyrgyz`,
  la: $localize`:@@languages.latin:Latin`,
  lb: $localize`:@@languages.luxembourgish:Luxembourgish`,
  lg: $localize`:@@languages.ganda:Ganda`,
  li: $localize`:@@languages.limburgish:Limburgish`,
  ln: $localize`:@@languages.lingala:Lingala`,
  lo: $localize`:@@languages.lao:Lao`,
  lt: $localize`:@@languages.lithuanian:Lithuanian`,
  lu: $localize`:@@languages.luba-katanga:Luba-Katanga`,
  lv: $localize`:@@languages.latvian:Latvian`,
  mg: $localize`:@@languages.malagasy:Malagasy`,
  mh: $localize`:@@languages.marshallese:Marshallese`,
  mi: $localize`:@@languages.maori:Maori`,
  mk: $localize`:@@languages.macedonian:Macedonian`,
  ml: $localize`:@@languages.malayalam:Malayalam`,
  mn: $localize`:@@languages.mongolian:Mongolian`,
  mr: $localize`:@@languages.marathi:Marathi`,
  ms: $localize`:@@languages.malay:Malay`,
  mt: $localize`:@@languages.maltese:Maltese`,
  my: $localize`:@@languages.burmese:Burmese`,
  na: $localize`:@@languages.nauru:Nauru`,
  nb: $localize`:@@languages.norwegian_nb:Norwegian (NB)`,
  nd: $localize`:@@languages.north_ndebele:North Ndebele`,
  ne: $localize`:@@languages.nepali:Nepali`,
  ng: $localize`:@@languages.ndonga:Ndonga`,
  nl: $localize`:@@languages.dutch:Dutch`,
  nn: $localize`:@@languages.norwegian_nynorsk:Norwegian Nynorsk`,
  no: $localize`:@@languages.norwegian_no:Norwegian (NO)`,
  nr: $localize`:@@languages.south ndebele:South Ndebele`,
  nv: $localize`:@@languages.navaho:Navaho`,
  ny: $localize`:@@languages.chichewa:Chichewa`,
  oc: $localize`:@@languages.occitan:Occitan`,
  oj: $localize`:@@languages.ojibwe:Ojibwe`,
  om: $localize`:@@languages.oromo:Oromo`,
  or: $localize`:@@languages.oriya:Oriya`,
  os: $localize`:@@languages.ossetian:Ossetian`,
  pa: $localize`:@@languages.panjabi:Panjabi`,
  pi: $localize`:@@languages.pali:Pali`,
  pl: $localize`:@@languages.polish:Polish`,
  ps: $localize`:@@languages.pashto:Pashto`,
  pt: $localize`:@@languages.portuguese:Portuguese`,
  qu: $localize`:@@languages.quechua:Quechua`,
  rm: $localize`:@@languages.romansh:Romansh`,
  rn: $localize`:@@languages.kirundi:Kirundi`,
  ro: $localize`:@@languages.romanian:Romanian`,
  ru: $localize`:@@languages.russian:Russian`,
  rw: $localize`:@@languages.kinyarwanda:Kinyarwanda`,
  sa: $localize`:@@languages.sanskrit:Sanskrit`,
  sc: $localize`:@@languages.sardinian:Sardinian`,
  sd: $localize`:@@languages.sindhi:Sindhi`,
  se: $localize`:@@languages.northern_sami:Northern Sami`,
  sg: $localize`:@@languages.sango:Sango`,
  si: $localize`:@@languages.sinhala:Sinhala`,
  sk: $localize`:@@languages.slovak:Slovak`,
  sl: $localize`:@@languages.slovene:Slovene`,
  sm: $localize`:@@languages.samoan:Samoan`,
  sn: $localize`:@@languages.shona:Shona`,
  so: $localize`:@@languages.somali:Somali`,
  sq: $localize`:@@languages.albanian:Albanian`,
  sr: $localize`:@@languages.serbian:Serbian`,
  ss: $localize`:@@languages.swati:Swati`,
  st: $localize`:@@languages.southern_sotho:Southern Sotho`,
  su: $localize`:@@languages.sundanese:Sundanese`,
  sv: $localize`:@@languages.swedish:Swedish`,
  sw: $localize`:@@languages.swahili:Swahili`,
  ta: $localize`:@@languages.tamil:Tamil`,
  te: $localize`:@@languages.telugu:Telugu`,
  tg: $localize`:@@languages.tajik:Tajik`,
  th: $localize`:@@languages.thai:Thai`,
  ti: $localize`:@@languages.tigrinya:Tigrinya`,
  tk: $localize`:@@languages.turkmen:Turkmen`,
  tl: $localize`:@@languages.tagalog:Tagalog`,
  tn: $localize`:@@languages.tswana:Tswana`,
  to: $localize`:@@languages.tonga:Tonga`,
  tr: $localize`:@@languages.turkish:Turkish`,
  ts: $localize`:@@languages.tsonga:Tsonga`,
  tt: $localize`:@@languages.tatar:Tatar`,
  tw: $localize`:@@languages.twi:Twi`,
  ty: $localize`:@@languages.tahitian:Tahitian`,
  ug: $localize`:@@languages.uyghur:Uyghur`,
  uk: $localize`:@@languages.ukrainian:Ukrainian`,
  ur: $localize`:@@languages.urdu:Urdu`,
  uz: $localize`:@@languages.uzbek:Uzbek`,
  ve: $localize`:@@languages.venda:Venda`,
  vi: $localize`:@@languages.vietnamese:Vietnamese`,
  vo: $localize`:@@languages.volapak:Volapak`,
  wa: $localize`:@@languages.walloon:Walloon`,
  wo: $localize`:@@languages.wolof:Wolof`,
  xh: $localize`:@@languages.xhosa:Xhosa`,
  yi: $localize`:@@languages.yiddish:Yiddish`,
  yo: $localize`:@@languages.yoruba:Yoruba`,
  za: $localize`:@@languages.zhuang:Zhuang`,
  zh: $localize`:@@languages.chinese:Chinese`,
  zu: $localize`:@@languages.zulu:Zulu`,
};
export const MONTHS_TRANSLATIONS = {
  1: $localize`:@@common.january:January`,
  2: $localize`:@@common.february:February`,
  3: $localize`:@@common.march:March`,
  4: $localize`:@@common.april:April`,
  5: $localize`:@@common.may:May`,
  6: $localize`:@@common.june:June`,
  7: $localize`:@@common.july:July`,
  8: $localize`:@@common.august:August`,
  9: $localize`:@@common.september:September`,
  10: $localize`:@@common.october:October`,
  11: $localize`:@@common.november:November`,
  12: $localize`:@@common.december:December`,
};

export const OFFER_PRIVACY_TRANSLATIONS = {
  0: $localize`:@@common.public:Public`,
  1: $localize`:@@common.private:Private`,
  2: $localize`:@@common.request_only:Request Only`,
};

export const OFFER_STATUS_TRANSLATIONS = {
  0: $localize`:@@common.disabled:Disabled`,
  1: $localize`:@@common.active:Active`,
  2: $localize`:@@common.paused:Paused`,
};

export const POSTBACK_STATUS_TRANSLATIONS = {
  0: $localize`:@@common.blocked:Blocked`,
  1: $localize`:@@common.active:Active`,
  2: $localize`:@@common.pending:Pending`,
};
export const ADVERTISER_SYSTEM_ROLE_TRANSLATIONS = {
  0: $localize`:@@advertiser.compliance_officer:Compliance Officer`,
  1: $localize`:@@advertiser.user_per_brand:User Per Brand`,
};

export const CRM_DOCUMENT_TYPE_TRANSLATIONS = {
  2: $localize`:@@common.terms_&_conditions:Terms and Conditions`,
  4: $localize`:@@common.privacy_policy:Privacy Policy`,
};

export const CRM_QUESTION_TYPES_TRANSLATIONS = {
  1: $localize`:@@common.affiliate_&_advertiser:Affiliate and Advertiser`,
  2: $localize`:@@common.affiliate:Affiliate`,
  3: $localize`:@@common.advertiser:Advertiser`,
};

export const EARNING_STATUS_TRANSLATIONS = {
  [EARNING_STATUSES.PAID]: $localize`:@@common.paid:Paid`,
  [EARNING_STATUSES.DRAFT]: $localize`:@@common.drafts:Draft`,
  [EARNING_STATUSES.APPLIED]: $localize`:@@common.applied:Applied`,
  [EARNING_STATUSES.ARCHIVED]: $localize`:@@common.archived:Archived`,
};

export const INVOICE_STATUSES_TRANSLATIONS = {
  [INVOICE_STATUSES.APPROVED]: $localize`:@@common.approved:Approved`,
  [INVOICE_STATUSES.DECLINED]: $localize`:@@common.declined:Declined`,
  [INVOICE_STATUSES.DRAFT]: $localize`:@@common.draft:Draft`,
  [INVOICE_STATUSES.PAID]: $localize`:@@common.paid:Paid`,
  [INVOICE_STATUSES.PENDING]: $localize`:@@common.pending:Pending`,
  [INVOICE_STATUSES.WAITING]: $localize`:@@common.waiting:Waiting`,
  [INVOICE_STATUSES.SENT]: $localize`:@@common.sent:Sent`,
  [INVOICE_STATUSES.ARRIVED]: $localize`:@@common.arrived:Arrived`,
};

export const CONDITIONS_TRANSLATIONS: Record<string, string> = {
  Offer: $localize`:@@common.offer:Offer`,
  Country: $localize`:@@common.country:Country`,
  Browser: $localize`:@@common.browser:Browser`,
  'Device OS': $localize`:@@common.device_os:Device OS`,
  'Device OS Version': $localize`:@@common.device_os_version:Device OS Version`,
  'Device Model': $localize`:@@common.device_model:Device Model`,
  'Device Brand': $localize`:@@common.device_brand:Device Brand`,
  Platform: $localize`:@@common.platform:Platform`,
  'Aff Sub': $localize`:@@common.aff_sub:Aff Sub`,
  'Goal Type': $localize`:@@common.goal_type:Goal Type`,
  'Sale Status': $localize`:@@common.sale_status:Sale Status`,
  'Revenue Model': $localize`:@@common.revenue_model:Revenue Model`,
  'Country Code': $localize`:@@common.country_code:Country Code`,
  'Payout Model': $localize`:@@common.payout:Payout Model`,
  'Conversion Tracking Type': $localize`:@@conversion.tracking_type:Conversion Tracking Type`,
  Goal: $localize`:@@common.goal:Goal`,
  'Goal Type Exists': $localize`:@@goal.type_exists:Goal Type Exists`,
  'Is Unique': $localize`:@@common.is_unique:Is Unique`,
  'Is Test': $localize`:@@common.is_test:Is Test`,
  Affiliate: $localize`:@@common.affiliate:Affiliate`,
  Advertiser: $localize`:@@common.advertiser:Advertiser`,
  'Affiliate Questions': $localize`:@@affiliate.questions:Affiliate Questions`,
  'Affiliate Answers': $localize`:@@affiliate.answers:Affiliate Answers`,
  'Is Approved': $localize`:@@common.is_approved:Is Approved`,
  Brand: $localize`:@@common.brand:Brand`,
  'Is White': $localize`:@@common.is_white:Is White`,
  'Language Code': $localize`:@@common.language_code:Language Code`,
  'Offer Url Name': $localize`:@@offer.url_name:Offer URL Name`,
  'Has Conversions': $localize`:@@conversion.has_conversions:Has Conversions`,
  'Affiliate ID': $localize`:@@affiliate.id:Affiliate ID`,
  'Payment Status': $localize`:@@finance.payment_status:Payment Status`,
  'Invoice Status': $localize`:@@invoice.status:Invoice Status`,
  'Earning Status': $localize`:@@earning.status:Earning Status`,
  'Offer URL Name': $localize`:@@offer.url_name:Offer URL Name`,
  'Affiliate Source': $localize`:@@affiliate.source:Affiliate Source`,
  Currency: $localize`:@@common.currency:Currency`,
  'Affiliate Manager': $localize`:@@affiliate.manager:Affiliate Manager`,
  'Affiliate Group': $localize`:@@affiliate.group:Affiliate Group`,
  'Affiliate Consolidation': $localize`:@@common.affiliate_consolidation:Affiliate Consolidation`,
  Activity: $localize`:@@common.activity:Activity`,
  'Exists In Current Month': $localize`:@@common.exists_in_current_month:Exists In Current Month`,
  'Transaction Type': $localize`:@@common.transaction_type:Transaction Type`,
  'Advertiser Brand': $localize`:@@common.advertiser_brand:Advertiser Brand`,
  'Manual Created': $localize`:@@common.manual_created:Manual Created`,
  'Is Late': $localize`:@@common.is_late:Is Late`,
  Qualified: $localize`:@@common.qualified:Qualified`,
  'Traffic Source': $localize`:@@offer.traffic_source:Traffic Source`,
  Category: $localize`:@@common.category:Category`,
  Vertical: $localize`:@@offer.vertical:Vertical`,
};

export const FORMAT_TRANSLATIONS = {
  money: $localize`:@@common.money:Money`,
  percentage: $localize`:@@common.percentage:Percentage`,
  number: $localize`:@@common.number:Number`,
};

export const AFFILIATE_REQUESTS_STATUS_TRANSLATIONS: Record<string, string> = {
  [AFFILIATE_REQUEST_STATUSES.REQUESTED]: $localize`:@@common.requested:Requested`,
  [AFFILIATE_REQUEST_STATUSES.APPROVED]: $localize`:@@common.approved:Approved`,
  [AFFILIATE_REQUEST_STATUSES.DECLINED]: $localize`:@@common.declined:Declined`,
};

export const NEGATIVE_PERIOD_TRANSLATIONS = {
  Month: $localize`:@@dates.month:Month`,
  Week: $localize`:@@dates.week:Week`,
};

export const TRANSACTION_TYPE_TRANSLATIONS = {
  0: $localize`:@@transaction.bonus:Bonus`,
  1: $localize`:@@transaction.no_negative_carry_over:No Negative Carry Over`,
  3: $localize`:@@transaction.master_fee:Master Fee`,
  4: $localize`:@@transaction.referral_bonus:Referral Bonus`,
  5: $localize`:@@transaction.referral_correction_entry:Referral Correction Entry`,
};

export const CRM_PARTNER_TYPES = {
  Approval: $localize`:@@common.approval:Approval`,
  'Auto Approve': $localize`:@@common.auto_approve:Auto Approve`,
  Disabled: $localize`:@@common.disabled:Disabled`,
  'Referral Only': $localize`:@@common.referral_only:Referral Only`,
};

export const KYC_TYPES = {
  0: $localize`:@@settings.upload_from_affiliate:Upload From Affiliate`,
  1: $localize`:@@settings.provided_from_affiliate_manager:Provided From Affiliate Manager`,
};

export const KYC_APPROVE_MODES = {
  0: $localize`:@@settings.by_affiliate_manager:By Affiliate Manager`,
  1: $localize`:@@settings.by_affiliate:By Affiliate`,
  2: $localize`:@@common.auto:Provided From Affiliate Manager`,
};
export const OFFER_VERTICAL_TRANSLATIONS = {
  1: $localize`:@@common.adult:Adult`,
  2: $localize`:@@common.automotive:Automotive`,
  4: $localize`:@@common.biz_opp:Biz Opp`,
  8: $localize`:@@common.casino_gambling:Casino Gambling`,
  16: $localize`:@@common.coupons:Coupons`,
  32: $localize`:@@common.dating:Dating`,
  64: $localize`:@@common.downloads_software:Downloads Software`,
  128: $localize`:@@common.education:Education`,
  512: $localize`:@@common.entertainment:Entertainment`,
  1024: $localize`:@@common.fashion:Fashion`,
  2048: $localize`:@@common.finance:Finance`,
  4096: $localize`:@@common.forex:Forex`,
  8192: $localize`:@@common.games:Games`,
  16384: $localize`:@@common.health_amp:Health Amp`,
  32768: $localize`:@@common.beauty:Beauty`,
  65536: $localize`:@@common.home_improvements:Home Improvements`,
  131072: $localize`:@@common.insurance:Insurance`,
  262144: $localize`:@@common.legal:Legal`,
  524288: $localize`:@@common.lifestyle:Lifestyle`,
  1048576: $localize`:@@common.music:Music`,
  2097152: $localize`:@@common.other:Other`,
  4194304: $localize`:@@common.real_Estate_mortgage:Real Estate Mortgage`,
  8388608: $localize`:@@common.shopping:Shopping`,
  16777216: $localize`:@@common.sports:Sports`,
  33554432: $localize`:@@common.sweepstakes:Sweepstakes`,
  67108864: $localize`:@@common.travel:Travel`,
  134217728: $localize`:@@common.utilities:Utilities`,
};

export const TOKEN_TYPE_TRANSLATIONS = {
  affiliate: $localize`:@@common.affiliate:Affiliate`,
  affiliate_manager: $localize`:@@common.affiliate_manager:Affiliate Manager`,
  user: $localize`:@@common.user:User`,
};

export const POSTBACK_CONTEXT_TRANSLATIONS = {
  bonus_cash: $localize`:@@conversion.bonus_cash:Bonus Cash`,
  charge_back_amount: $localize`:@@common.charge_back_amount:Charge Back Amount`,
  net_gaming_cash: $localize`:@@conversion.net_gaming_cash:Net Gaming Cash`,
  sale_amount: $localize`:@@common.sale_amount:Sale Amount`,
  wagered_bonus: $localize`:@@conversion.wagered_bonus:Wagered Bonus`,
  withdrawal_fee: $localize`:@@common.withdrawal_fee:Withdrawal Fee`,
  unique: $localize`:@@common.unique:Unique`,
  bet_amount: $localize`:@@common.bet_amount:Bet Amount`,
  deposit_amount: $localize`:@@common.deposit_amount:Deposit Amount`,
  net_gaming_amount: $localize`:@@common.net_gaming_amount:Net Gaming Amount`,
  win_amount: $localize`:@@common.win_amount:Win Amount`,
  withdrawal_amount: $localize`:@@common.withdrawal_amount:Withdrawal Amount`,
};

export const ACTIVITY_STATUS_BOOLEAN_TRANSLATIONS = {
  0: $localize`:@@common.inactive:Inactive`,
  1: $localize`:@@common.active:Active`,
};

export const COUNTRY_REGIONS_TRANSLATIONS = {
  US: {
    AL: $localize`:@@regions.alabama:Alabama`,
    AK: $localize`:@@regions.alaska:Alaska`,
    AZ: $localize`:@@regions.arizona:Arizona`,
    AR: $localize`:@@regions.arkanzas:Arkanzas`,
    CA: $localize`:@@regions.california:California`,
    CO: $localize`:@@regions.colorado:Colorado`,
    CT: $localize`:@@regions.connecticut:Connecticut`,
    DE: $localize`:@@regions.delaware:Delaware`,
    DC: $localize`:@@regions.district_of_columbia:District of Columbia`,
    FL: $localize`:@@regions.florida:Florida`,
    GA: $localize`:@@regions.georgia:Georgia`,
    HI: $localize`:@@regions.hawaii:Hawaii`,
    ID: $localize`:@@regions.idaho:Idaho`,
    IL: $localize`:@@regions.illinois:Illinois`,
    IN: $localize`:@@regions.indiana:Indiana`,
    IA: $localize`:@@regions.iowa:Iowa`,
    KS: $localize`:@@regions.kansas:Kansas`,
    KY: $localize`:@@regions.kentucky:Kentucky`,
    LA: $localize`:@@regions.louisiana:Louisiana`,
    ME: $localize`:@@regions.maine:Maine`,
    MD: $localize`:@@regions.maryland:Maryland`,
    MA: $localize`:@@regions.massachusetts:Massachusetts`,
    MI: $localize`:@@regions.michigan:Michigan`,
    MN: $localize`:@@regions.minnesota:Minnesota`,
    MS: $localize`:@@regions.mississippi:Mississippi`,
    MO: $localize`:@@regions.missouri:Missouri`,
    MT: $localize`:@@regions.montana:Montana`,
    NE: $localize`:@@regions.nebraska:Nebraska`,
    NV: $localize`:@@regions.nevada:Nevada`,
    NH: $localize`:@@regions.new_hampshire:New Hampshire`,
    NJ: $localize`:@@regions.new_jersey:New Jersey`,
    NM: $localize`:@@regions.new_mexico:New Mexico`,
    NY: $localize`:@@regions.new_york:New York`,
    NC: $localize`:@@regions.north_carolina:North Carolina`,
    ND: $localize`:@@regions.north_dakota:North Dakota`,
    OH: $localize`:@@regions.ohio:Ohio`,
    OK: $localize`:@@regions.oklahoma:Oklahoma`,
    OR: $localize`:@@regions.oregon:Oregon`,
    PA: $localize`:@@regions.pennsylvania:Pennsylvania`,
    RI: $localize`:@@regions.rhode_island:Rhode Island`,
    SC: $localize`:@@regions.south_carolina:South Carolina`,
    SD: $localize`:@@regions.south_dakota:South Dakota`,
    TN: $localize`:@@regions.tennessee:Tennessee`,
    TX: $localize`:@@regions.texas:Texas`,
    UT: $localize`:@@regions.utah:Utah`,
    VT: $localize`:@@regions.vermont:Vermont`,
    VA: $localize`:@@regions.virginia:Virginia`,
    WA: $localize`:@@regions.washington:Washington`,
    WV: $localize`:@@regions.west_virginia:West Virginia`,
    WI: $localize`:@@regions.wisconsin:Wisconsin`,
    WY: $localize`:@@regions.wyoming:Wyoming`,
  },
  IN: {
    AP: $localize`:@@regions:Andhra Pradesh`,
    AR: $localize`:@@regions:Arunachal Pradesh`,
    AS: $localize`:@@regions:Assam`,
    BR: $localize`:@@regions:Bihar`,
    CT: $localize`:@@regions:Chhattisgarh`,
    GA: $localize`:@@regions:Goa`,
    GJ: $localize`:@@regions:Gujarat`,
    HR: $localize`:@@regions:Haryana`,
    HP: $localize`:@@regions:Himachal Pradesh`,
    JH: $localize`:@@regions:Jharkhand`,
    KA: $localize`:@@regions:Karnataka`,
    KL: $localize`:@@regions:Kerala`,
    MP: $localize`:@@regions:Madhya Pradesh`,
    MH: $localize`:@@regions:Maharashtra`,
    MN: $localize`:@@regions:Manipur`,
    ML: $localize`:@@regions:Meghalaya`,
    MZ: $localize`:@@regions:Mizoram`,
    NL: $localize`:@@regions:Nagaland`,
    OD: $localize`:@@regions:Odisha`,
    PB: $localize`:@@regions:Punjab`,
    RJ: $localize`:@@regions:Rajasthan`,
    SK: $localize`:@@regions:Sikkim`,
    TN: $localize`:@@regions:Tamil Nadu`,
    TG: $localize`:@@regions:Telangana`,
    TR: $localize`:@@regions:Tripura`,
    UP: $localize`:@@regions:Uttar Pradesh`,
    UT: $localize`:@@regions:Uttarakhand`,
    WB: $localize`:@@regions:West Bengal`,
    AN: $localize`:@@regions:Andaman and Nicobar Islands`,
    CH: $localize`:@@regions:Chandigarh`,
    DH: $localize`:@@regions:Dadra and Nagar Haveli and Daman and Diu`,
    DL: $localize`:@@regions:Delhi`,
    JK: $localize`:@@regions:Jammu and Kashmir`,
    LA: $localize`:@@regions:Ladakh`,
    LD: $localize`:@@regions:Lakshadweep`,
    PY: $localize`:@@regions:Puducherry`,
  },
};
